/**
 * Переиспользуемые библиотеки пользователя: герои, вещи, локации
 * (01-SPEC.md §3.5–§3.7). Здесь — только та часть модели, которая нужна
 * контракту: сбор промптов и валидация форм.
 */
import { z } from 'zod';
export const CharacterKindSchema = z.enum(['child', 'adult', 'pet']);
export const EntityStatusSchema = z.enum(['draft', 'ready']);
/**
 * Внешность героя (01-SPEC.md §3.5). Структурирована именно затем,
 * чтобы из неё собирался промпт листа персонажа.
 */
export const CharacterAppearanceSchema = z.object({
    hair: z.string().default(''),
    eyes: z.string().default(''),
    marks: z.string().default(''),
    outfit: z.string().default(''),
    build: z.string().default(''),
});
export const CharacterInputSchema = z.object({
    name: z.string().min(1),
    displayName: z.string().default(''),
    kind: CharacterKindSchema.default('child'),
    role: z.string().default(''),
    ageYears: z.number().int().min(0).max(120).nullable().default(null),
    gender: z.string().default(''),
    traits: z.array(z.string().min(1)).default([]),
    appearance: CharacterAppearanceSchema.default({}),
    favouriteActivities: z.array(z.string().min(1)).default([]),
    catchphrase: z.string().default(''),
    /** Итоговый промпт листа персонажа — генерируется из полей, редактируем вручную. */
    promptEn: z.string().default(''),
    status: EntityStatusSchema.default('draft'),
});
export const THING_CATEGORIES = ['toy', 'clothing', 'dish', 'furniture', 'other'];
export const ThingCategorySchema = z.enum(THING_CATEGORIES);
export const ThingInputSchema = z.object({
    name: z.string().min(1),
    category: ThingCategorySchema.default('other'),
    descriptionRu: z.string().default(''),
    promptEn: z.string().default(''),
    status: EntityStatusSchema.default('draft'),
});
export const LOCATION_KINDS = [
    'room',
    'kitchen',
    'outdoor',
    'transport',
    'imaginary',
    'other',
];
export const LocationKindSchema = z.enum(LOCATION_KINDS);
export const LocationInputSchema = z.object({
    name: z.string().min(1),
    kind: LocationKindSchema.default('other'),
    descriptionRu: z.string().default(''),
    promptEn: z.string().default(''),
    status: EntityStatusSchema.default('draft'),
});
//# sourceMappingURL=library.js.map